export default __webpack_public_path__ + "static/media/icon-close.c2e36e04.svg";